import { render, staticRenderFns } from "./ChatTypeTabs.vue?vue&type=template&id=3ffa33d1&"
import script from "./ChatTypeTabs.vue?vue&type=script&lang=js&"
export * from "./ChatTypeTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports